export class FiltrosRepContabilidad{
   
    Usuario : string ='';
    Estado: string = '';
    Tipo: string = 'factura_generada';
    idEmpresa_Factor: string = '7';
 
 }